import Driveway from '../../images/coverPhoto1.JPEG';
import Chessboard from '../../images/coverPhoto2.JPEG';
import Kids from '../../images/coverPhoto3.JPEG';
import Flowers from '../../images/coverPhoto4.jpg';

export const images = [
    {
        title: "The Only U-Pick Farm in Willis County",
        altTag: "Driveway with white fence and barn in background with the sun behind the tress",
        img: Driveway
    },
    {
        title: "The Only U-Pick Farm in Willis County",
        altTag: "Life-size chessboard with barn and farm in background",
        img: Chessboard
    },
    {
        title: "The Only U-Pick Farm in Willis County",
        altTag: "Children playing on a slackline in the playgarden",
        img: Kids
    },
    {
        title: "The Only U-Pick Farm in Willis County",
        altTag: "Flowers and Butterflies in the garden",
        img: Flowers
    }
]